module.exports = __webpack_public_path__ + "static/media/hiphop.172c74ba.jpg";